module.exports = __webpack_public_path__ + "img/di_24_Pengaturan.b94a21c9.png";